import { Notification } from '../types';

export const addNotification = (notifications: Notification[], notification: Notification): Notification[] => {
  return [notification, ...notifications];
};

export const removeNotification = (notifications: Notification[], id: number): Notification[] => {
  return notifications.filter((notification: Notification) => notification.id !== id);
};
